import React from "react"
import { Icon } from "@autouncle/ui"
import styled from "styled-components"

const IconContainer = styled.div<{ $color?: string }>`
  display: contents;
  ${(props) => (props.$color ? `color: ${props.$color};` : "")}
`

// Generates an icon component that can be passed to NavigationLink
// Used because NavigationLink doesn't support @autouncle/icons svgs directly
const NavIcon = (svg: React.FC) => {
  const Svg = svg
  // Sets the color according to the fill
  const Comp = ({ fill }: { fill?: string }) => (
    <IconContainer $color={fill}>
      <Icon svg={<Svg />} size="lg" />
    </IconContainer>
  )
  Comp.displayName = "NavIcon"
  return Comp
}

export default NavIcon
